import {
  Button,
  IconButton,
  Tab,
  Tabs,
  RadioGroup,
  Radio,
  FormControlLabel,
} from '@material-ui/core';
import CustomSelect from '../../../../../shared/form-controls/custom-select/Custom-Select';
import { REDIRECT_OPTIONS } from '../../../../../constants/SpaConst';
import { withStyles } from '@material-ui/core/styles';
import CancelIcon from '@material-ui/icons/Cancel';
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import MuiPhoneNumber from 'material-ui-phone-number';
import { FormControl } from '@mui/material';
import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ASSET_TYPE_DOC, ASSET_TYPE_PROPERTY } from '../../../../../constants/PropertyConst';
import { CONTACT_INFO_TYPES } from '../../../../../constants/restaurantConst';
import { DAYS, SPA_TYPE } from '../../../../../constants/SpaConst';
import ContactInformation from '../../../../../shared/contact-information/ContactInformation';
import CustomHours from '../../../../../shared/custom-hours/Custom-Hours';
import CustomCheckbox from '../../../../../shared/form-controls/custom-checkbox/Custom-Checkbox';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import CustomUpload from '../../../../../shared/form-controls/custom-upload/Custom-Upload';
import { getProcessedImages } from '../../../../../shared/image-upload/ImageProcessor';
import ImageUpload from '../../../../../shared/image-upload/ImageUpload';
import KeyValuePairList from '../../../../../shared/key-value-pair-list/KeyValuePairList';
import LocationInputTab from '../../../../../shared/location-input-tab/Location-Input-Tab';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import { parseObj } from '../../../../../utils/commonUtils';
import {
  decodeMediaKeyValue,
  renderVideos,
  renderGifs,
  toMediaContent,
  processGifsForUpload,
} from '../../../../../utils/mediaUtils';
import { formDataValidate, handleValidation } from '../../../../../utils/formUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import {
  createSpa,
  getPreSignedUrl,
  updateSpaDetails,
} from '../../../../../utils/PropertyAPIUtils';
import { allHotelsSelector, fetchAllSpa } from '../../../../property/propertySlice';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';
import { MAX_PDF_SIZE } from '../../../../../utils/Constants';
import { ASSET_URL } from '../../../../../env/Configurations';

const CustomToolTip = withStyles({
  tooltip: {
    color: 'white',
    backgroundColor: 'black',
  },
})(Tooltip);

const SpaInfoCreate = (props) => {
  const dispatch = useDispatch();
  const originalHotels = useSelector(allHotelsSelector);
  const [tabValue, setTabValue] = useState(0);
  const [rawImages, setRawImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [days, setDays] = useState();
  const [customTime, setCustomTime] = useState([]);
  const [customTimeError, setCustomTimeError] = useState({
    status: false,
    message: '',
  });
  const [contactInfoList, setContactInfoList] = useState([]);
  const { toggleDrawer, spaInfoItem, hotelId, showLoader = () => {} } = props;
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [countryCode, setCountryCode] = useState('');
  const [rawVideos, setRawVideos] = useState([]);
  const [rawGifs, setRawGifs] = useState([]);
  const [videoImageUrl, setVideoImageUrl] = useState('');
  const [gifImageUrl, setGifImageUrl] = useState('');
  const [hasVideoError, setHasVideoError] = useState(false);
  const [isThumbnailUploading, setIsThumbnailUploading] = useState(false);
  const [isVideoLoading, setIsVideoLoading] = useState(false);
  const [isGifLoading, setIsGifLoading] = useState(false);

  const groupId = originalHotels?.find((hotel) => hotel?.id === hotelId)?.groupId;
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    name: {
      value: '',
      fieldName: 'Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    code: {
      value: '',
      fieldName: 'Code',
      errors: {},
      validations: ['required', 'validAlphaNumeric'],
      tab: 0,
    },
    description: {
      value: '',
      fieldName: 'Description',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    isActive: {
      value: true,
      fieldName: 'Active',
      errors: {},
      validations: [],
      tab: 0,
    },
    treatmentsMenu: {
      value: {
        url: parseObj(spaInfoItem?.treatmentsMenu)?.url,
        type: parseObj(spaInfoItem?.treatmentsMenu)?.type,
        name: parseObj(spaInfoItem?.treatmentsMenu)?.name,
      },
      fieldName: 'Treatments Menu',
      errors: {},
      validations: ['required', 'validIfUrl', 'safeURL'],
      tab: 0,
    },
    customAttributes: {
      value: [],
      fieldName: 'Custom Attributes',
      errors: {},
      validations: [],
      tab: 0,
    },
    availableOn: {
      value: 'everyDay',
      fieldName: 'availableOn',
      errors: {},
      validations: [],
      tab: 1,
    },
    days: {
      value: [],
      fieldName: 'days',
      errors: {},
      validations: [],
      tab: 1,
    },
    hours: {
      value: 'allTime',
      fieldName: 'Hours',
      errors: {},
      validations: [],
      tab: 1,
    },
    from: {
      value: '11:00',
      fieldName: 'Hours From',
      errors: {},
      validations: ['validTime'],
      tab: 1,
    },
    to: {
      value: '23:00',
      fieldName: 'Hours To',
      errors: {},
      validations: ['validTime'],
      tab: 1,
    },
    email: {
      value: '',
      fieldName: 'Email Id',
      errors: {},
      validations: ['validEmail'],
      tab: 2,
    },
    phoneNumber: {
      value: '',
      fieldName: 'Phone Number',
      errors: {},
      validations: ['validatePhone'],
      maxLimit: 10,
      tab: 2,
    },
    addressLine1: {
      value: '',
      fieldName: 'Address Line 1',
      errors: {},
      validations: ['required'],
      tab: 3,
    },
    addressLine2: {
      value: '',
      fieldName: 'Address Line 2',
      errors: {},
      validations: [],
      tab: 3,
    },
    country: {
      value: '',
      fieldName: 'Country',
      errors: {},
      validations: ['required'],
      tab: 3,
    },
    state: {
      value: '',
      fieldName: 'State',
      errors: {},
      validations: ['required'],
      tab: 3,
    },
    postalCode: {
      value: '',
      fieldName: 'Postal Code',
      errors: {},
      validations: [],
      tab: 3,
    },
    city: {
      value: '',
      fieldName: 'City',
      errors: {},
      validations: ['required'],
      tab: 3,
    },
    latitude: {
      value: '',
      fieldName: 'Latitude',
      errors: {},
      validations: [],
      tab: 3,
    },
    longitude: {
      value: '',
      fieldName: 'Longitude',
      errors: {},
      validations: [],
      tab: 3,
    },
    area: {
      value: '',
      fieldName: 'Area (Ex: Downtown Avenue)',
      errors: {},
      validations: ['required'],
      tab: 3,
    },
    timeZone: {
      value: '',
      fieldName: 'Time Zone',
      errors: {},
      validations: ['required'],
      tab: 3,
    },
    menuStatus: {
      value: 'Inactive',
      fieldName: 'Menu Status',
      validations: [],
      tab: 0,
    },
    ctaTitle: {
      value: '',
      fieldName: 'CTA Title',
      errors: {},
      validations: ['required', 'maxLength'],
      maxLength: 30,
      tab: 4,
    },
    status: {
      value: 'Inactive',
      fieldName: 'CTA Status',
      validations: [],
      tab: 4,
    },
    redirectOption: {
      value: '',
      fieldName: 'Redirect Option',
      errors: {},
      validations: [],
      tab: 4,
    },
    redirectUrl: {
      value: '',
      fieldName: 'URL',
      placeholder: 'Please paste the redirect URL here',
      errors: {},
      validations: ['safeURL'],
      tab: 4,
    },
    images: {
      value: [],
      fieldName: 'Images',
      errors: {},
      validations: [],
      tab: 5,
    },
    videos: {
      value: [],
      fieldName: 'Videos',
      errors: {},
      validations: [],
      tab: 5,
    },
    gifs: {
      value: [],
      fieldName: 'GIFs',
      errors: {},
      validations: [],
      tab: 5,
    },
  });

  useEffect(() => {
    resetDaysData();
  }, []);

  useEffect(() => {
    const redirectUrl =
      formData.redirectOption.value === 'External URL'
        ? {
            ...formData.redirectUrl,
            validations: ['required', 'validUrl', 'safeURL'],
          }
        : { ...formData.redirectUrl, validations: [] };

    setFormData({ redirectUrl });
  }, [formData.redirectOption.value]);

  useEffect(() => {
    const redirectOption =
      formData.status.value === 'Inactive'
        ? { ...formData.redirectOption, validations: [] }
        : { ...formData.redirectOption, validations: ['required'] };

    setFormData({ redirectOption });
  }, [formData.status.value]);

  useEffect(() => {
    const redirectUrl =
      formData.status.value === 'Inactive'
        ? { ...formData.redirectUrl, validations: [] }
        : {
            ...formData.redirectUrl,
            validations: ['required', 'validUrl', 'safeURL'],
          };

    setFormData({ redirectUrl });
  }, [formData.status.value]);

  useEffect(() => {
    if (formData.redirectOption.value === 'SPA Booking Flow') {
      const redirectUrl = {
        value: '',
        fieldName: 'URL',
        placeholder: 'Please paste the redirect URL here',
        errors: {},
        validations: [],
        maxLength: 1000,
        tab: 4,
      };
      setFormData({ redirectUrl });
    }
  }, [formData.redirectOption.value]);

  useEffect(() => {
    if (spaInfoItem) {
      const currFields = { ...formData };
      for (let field in currFields) {
        currFields[field].value = spaInfoItem[field];
      }
      currFields.availableOn.value = spaInfoItem.hours.everyday ? 'everyDay' : 'custom';
      const isEveryDay = spaInfoItem.hours.timings.find((r) => r.day === 'EVERYDAY');
      currFields.hours.value = spaInfoItem.hours.allTime ? 'allTime' : 'custom';
      if (spaInfoItem.hours.timings.length > 0) {
        const daysToMap = formatArrayForDisplay(spaInfoItem.hours.timings);
        setCustomTime(daysToMap);
        let { url, type, name } = parseObj(spaInfoItem.treatmentsMenu);
        formData.treatmentsMenu.value = { url, type, name };
        currFields.availableOn.value =
          spaInfoItem.hours.timings[0].day === 'EVERYDAY' ? 'everyDay' : 'custom';
      }
      const startDate = new Date();
      currFields.from.value = formattedTime(startDate);
      const endDate = startDate.setHours(startDate.getHours() + 1);
      currFields.to.value = formattedTime(new Date(endDate));

      if (spaInfoItem.contact.information && spaInfoItem.contact.information.length > 0) {
        const riInfo = spaInfoItem?.contact?.information?.map((val, ndx) => {
          return { ...val };
        });
        setContactInfoList(riInfo);
      }
      currFields.addressLine1.value = spaInfoItem.location.addressLine1;
      currFields.addressLine2.value = spaInfoItem.location.addressLine2;
      currFields.country.value = spaInfoItem.location.country;
      currFields.state.value = spaInfoItem.location.state;
      currFields.postalCode.value = spaInfoItem.location.postalCode;
      currFields.city.value = spaInfoItem.location.city;
      currFields.area.value = spaInfoItem.location.area;
      currFields.latitude.value = spaInfoItem.location.latitude;
      currFields.longitude.value = spaInfoItem.location.longitude;
      currFields.timeZone.value = spaInfoItem.location.timeZone;
      currFields.email.value = spaInfoItem.contact.email;
      currFields.phoneNumber.value = spaInfoItem.contact.phone;
      currFields.images.value = spaInfoItem.images || [];
      currFields.customAttributes.value = spaInfoItem.customAttributes || [];
      currFields.ctaTitle.value = spaInfoItem.cta?.ctaTitle;
      currFields.redirectOption.value = spaInfoItem.cta?.redirectOption;
      currFields.redirectUrl.value = spaInfoItem.cta?.redirectUrl;
      currFields.status.value = spaInfoItem.cta?.status || 'Inactive';
      const { Video: videoMediaContent, GIF: gifMediaContent } = decodeMediaKeyValue(
        spaInfoItem.mediaContent,
      );
      const videoData = videoMediaContent || spaInfoItem.videos || {};
      const gifData = gifMediaContent || spaInfoItem.gifs || {};
      setVideoImageUrl(videoData.imageUrl || '');
      setGifImageUrl(gifData.imageUrl || '');
      setRawVideos(renderVideos(videoData));
      setRawGifs(renderGifs(gifData));

      setFormData(currFields);
    }
  }, [spaInfoItem, setFormData]);

  const formattedTime = (time) => {
    return time.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  };

  const formatArrayForDisplay = (selectedDay) => {
    const daysToReturn = [];
    let daysList = [...selectedDay];
    while (daysList.length > 0) {
      const firstObject = daysList[0];
      const filteredRows = daysList.filter(
        (dayKey) => dayKey.from === firstObject.from && dayKey.to === firstObject.to,
      );
      daysToReturn.push({
        days: filteredRows.map(
          (filteredRowDaysName) =>
            `${filteredRowDaysName.day.charAt(0).toUpperCase()}${filteredRowDaysName.day
              .slice(1)
              .toLowerCase()}`,
        ),
        from: filteredRows[0].from,
        to: filteredRows[0].to,
      });
      const tempDaysList = [...daysList];
      filteredRows.forEach((filteredRowsItem) => {
        const findFilteredDayIndex = tempDaysList.findIndex(
          (tempDaysListItem) => tempDaysListItem.day === filteredRowsItem.day,
        );
        tempDaysList.splice(findFilteredDayIndex, 1);
      });
      daysList = [...tempDaysList];
    }
    return daysToReturn;
  };

  const validate = (tabValue) => {
    const updatedFields = {};
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };


  const onImageListUpdated = (imgObjArr) => {
    setRawImages(imgObjArr);
  };

  const onUploadedImageRemoval = (index) => {
    const images = [...formData.images.value];
    images.splice(index, 1);
    setFormData({ images });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate(0) && validate(2) && validate(3)) {
      try {
        dispatch(stepUpLoaderCount());
        toggleDrawer('', false, '');
        const selectedLanguage = decryptLocalStorage('lang');
        const language = selectedLanguage !== 'en' ? selectedLanguage : '';
        e.preventDefault();
        setLoading(true);
        let selectedDay = [];
        for (let i = 0; i < customTime.length; i++) {
          if (customTime[i].days && customTime[i].days.length > 0) {
            for (let j = 0; j < customTime[i].days.length; j++) {
              selectedDay.push({
                day: customTime[i].days[j].toUpperCase(),
                from: customTime[i].from,
                to: customTime[i].to,
              });
            }
          }
        }
        const images = await getProcessedImages(
          rawImages,
          originalHotels?.find((hotel) => hotel?.id === hotelId)?.groupId,
          SPA_TYPE,
          hotelId,
        );

        const gifData = await processGifsForUpload({
          rawGifs,
          groupId,
          propertyType: SPA_TYPE,
          hotelId,
        });

        const mediaContent = toMediaContent({
          videoList: rawVideos,
          videoImageUrl,
          gifList: gifData,
          gifImageUrl,
        });

        const payload = {
          code: formData.code.value,
          name: formData.name.value,
          description: formData.description.value,
          isActive: formData.isActive.value,
          treatmentsMenu: formData.treatmentsMenu.value,
          customAttributes: formData.customAttributes.value,
          hours: {
            everyday: formData.availableOn.value === 'everyDay',
            allTime: formData.hours.value === 'allTime',
            timings: selectedDay,
          },
          contact: {
            email: formData.email.value,
            phone: formData.phoneNumber.value,
            information: contactInfoList,
          },
          location: {
            addressLine1: formData.addressLine1.value,
            addressLine2: formData.addressLine2.value,
            country: formData.country.value,
            state: formData.state.value,
            city: formData.city.value,
            area: formData.area.value,
            postalCode: formData.postalCode.value,
            latitude: formData.latitude.value,
            longitude: formData.longitude.value,
            timeZone: formData.timeZone.value,
          },
          menuStatus: formData.menuStatus.value,
          cta: {
            ctaTitle: formData.ctaTitle.value,
            redirectOption: formData.redirectOption.value,
            redirectUrl: formData.redirectUrl.value,
            status: formData.status.value,
          },
          images,
          mediaContent,
          hotelId,
        };
        if (spaInfoItem?.id) {
          payload.id = spaInfoItem.id;
          await updateSpaDetails(payload, language);
          notificationManager('success', 'Spa updated successfully');
        } else {
          await createSpa(payload, language);
          notificationManager('success', 'Spa created successfully');
        }
        dispatch(fetchAllSpa(hotelId));
        setLoading(false);
      } catch (error) {
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          spaInfoItem
            ? notificationManager('danger', 'Failed to update Spa')
            : notificationManager('danger', 'Failed to create Spa');
        }
        setLoading(false);
      } finally {
        dispatch(stepDownLoaderCount());
      }
    } else {
      notificationManager('danger', 'Enter all required fields');
      if (!validate(3)) {
        setTabValue(3);
      }
      if (!validate(2)) {
        setTabValue(2);
      }
      if (!validate(1)) {
        setTabValue(1);
      }
      if (!validate(0)) {
        setTabValue(0);
      }
    }
  };

  useEffect(() => {
    if (formData.menuStatus.value === 'Inactive') {
      const menu = {
        value: { url: '', type: '' },
        fieldName: 'Menu',
        errors: {},
        validations: ['validIfUrl', 'safeURL'],
        tab: 0,
      };
      setFormData({ menu });
    }
  }, [formData.menuStatus.value]);

  const onCtaStatusChange = (e) => {
    const status = {
      value: e.target.value,
      fieldName: 'CTA Status',
      validations: [],
      tab: 4,
    };
    setFormData({ ...formData, status });
    if (e.target.value === 'Inactive') {
      formData.ctaTitle.value = '';
      formData.redirectOption.value = '';
      formData.redirectUrl.value = '';
    }
  };

  useEffect(() => {
    const ctaTitle =
      formData.status.value === 'Inactive'
        ? { ...formData?.ctaTitle, validations: [] }
        : { ...formData?.ctaTitle, validations: ['required', 'maxLength'] };
    setFormData({ ctaTitle });
  }, [formData.status.value]);

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  const onNextClick = () => {
    if (validate(tabValue)) {
      setTabValue(tabValue + 1);
    }
  };

  const handleTabChange = (event, newValue) => {
    if (newValue < tabValue) {
      setTabValue(newValue);
      return true;
    }
    if (validate(tabValue)) {
      setTabValue(newValue);
    }
  };

  const resetDaysData = () => {
    const daysArray = DAYS.map((daysValue, ndx) => {
      return {
        id: ndx + 1,
        name: daysValue.name,
        ischecked: false,
        from: null,
        to: null,
      };
    });
    setDays(daysArray);
  };

  const handlePhoneNoChange = (phone, county) => {
    setCountryCode(county?.countryCode);
    const currField = { ...formData?.phoneNumber };
    if (`+${county.dialCode}` === phone) {
      currField.value = '';
    } else {
      currField.value = phone;
    }

    handleValidation(currField);
    setFormData({ ...formData, phoneNumber: currField });
  };

  useEffect(() => {
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, false);

    if (formData?.status?.value === 'Inactive') {
      setIsTabInValid(!isValid);
    } else {
      setIsTabInValid(!isValid);
    }
    if (
      tabValue === 2 &&
      !currTabFromData?.email?.errors?.required &&
      !currTabFromData?.email?.errors?.validEmail &&
      formData?.phoneNumber?.value !== ''
    ) {
      setIsTabInValid(formData?.phoneNumber?.value?.length < 10);
    }
  }, [formData, tabValue]);

  return (
    <form className='roomtype-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='d-flex row px-3 w-100 mt-4'>
          <div className='col-md-3'>
            <span className='page-title'>{spaInfoItem ? 'Edit Spa' : 'Add Spa'}</span>
          </div>
          <div className='col-md-8'>
            <Tabs
              value={tabValue}
              variant='fullWidth'
              indicatorColor='primary'
              onChange={handleTabChange}
              aria-label='roomTypes-add-tabs'
              textColor='primary'
              className='property-tabs'
            >
              <Tab label='Details' />
              <Tab label='Hours' />
              <Tab label='Contact' />
              <Tab label='Location' />
              <Tab label='CTA' />
              <Tab label='Media' />
            </Tabs>
          </div>
          <div className='col-md-1 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
          {tabValue === 0 && (
            <div className='row px-3 w-100 d-flex mt-4'>
              <h4 className='tab-title'>Details</h4>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.name}
                    handleInputChange={(e) => {
                      setFormData({ name: e });
                    }}
                    maxLength={100}
                    endAdornment={true}
                    characterCount={true}
                    multiline={true}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.code}
                    handleInputChange={(e) => {
                      setFormData({ code: e });
                    }}
                    maxLength={8}
                    endAdornment={true}
                    characterCount={true}
                    multiline={true}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 mb-3'>
                  <CustomTextField
                    item={formData.description}
                    handleInputChange={(e) => {
                      setFormData({ description: e });
                    }}
                    multiline={true}
                  />
                </div>
                <div className='col-md-3 mb-3'>
                  <div className='d-flex align-items-center'>
                    <CustomCheckbox
                      item={formData.isActive}
                      handleInputChange={(e) => {
                        setFormData({ isActive: e });
                      }}
                      color='primary'
                    />
                    <CustomToolTip
                      title='Deactivating this Spa hides it from Guest app'
                      placement='right-end'
                    >
                      <InfoIcon fontSize='small' style={{ marginLeft: 8 }} />
                    </CustomToolTip>
                  </div>
                </div>
              </div>

              <div className='col-md-12 mb-3 mt-4'>
                <h4 className='tab-title'>{formData.treatmentsMenu.fieldName}</h4>
                <CustomUpload
                  item={formData?.treatmentsMenu}
                  hotelId={hotelId}
                  additionalInput={{
                    type: ASSET_TYPE_DOC,
                    groupId: originalHotels.find((hotel) => hotel.id === hotelId).groupId,
                    propertyType: SPA_TYPE,
                  }}
                  onUpload={(e) => {
                    setFormData({ treatmentsMenu: e });
                  }}
                  webUrlPlaceholder='Paste URL'
                  maxFileSize={MAX_PDF_SIZE}
                />
              </div>

              <KeyValuePairList
                item={formData.customAttributes}
                onListChange={(e) => {
                  setFormData({ customAttributes: e });
                }}
              />
            </div>
          )}
          {tabValue === 1 && (
            <div className='col-md-12 mb-3'>
              <CustomHours
                setFormData={setFormData}
                formData={formData}
                days={days}
                customTime={customTime}
                setCustomTime={setCustomTime}
                validate={validate}
                tabValue={tabValue}
                customTimeError={customTimeError}
                setCustomTimeError={setCustomTimeError}
              />
            </div>
          )}
          {tabValue === 2 && (
            <div className='col-md-12 mb-3'>
              <h4 className='tab-title'>Contact</h4>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.email}
                    handleInputChange={(e) => {
                      setFormData({ email: e });
                    }}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <MuiPhoneNumber
                    name='phone'
                    label='Phone Number'
                    data-cy='user-phone'
                    defaultCountry={'in'}
                    disableAreaCodes
                    autoFormat={true}
                    countryCodeEditable={false}
                    value={formData?.phoneNumber?.value}
                    className='col-md-12'
                    error={formData?.phoneNumber?.errors?.required ? true : false}
                    helperText={formData?.phoneNumber?.errors?.required}
                    onChange={(phone, country) => handlePhoneNoChange(phone, country)}
                    sx={{ '& svg': { height: '1.2rem' } }}
                  />
                </div>
              </div>
              <h4 className='tab-title mt-3'>Information</h4>
              <ContactInformation
                informationTypes={CONTACT_INFO_TYPES}
                setContactInfoList={setContactInfoList}
                contactInfoList={contactInfoList}
                infoFieldKey='reviewerTitle'
                infoValueKey='url'
              />
            </div>
          )}
          {tabValue === 3 && <LocationInputTab formData={formData} setFormData={setFormData} />}
          {tabValue === 4 && (
            <div className='col-md-12 mb-3'>
              <h4 className='tab-title'>CTA</h4>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby='demo-radio-buttons-group-label'
                  defaultValue={formData.status.value || 'Inactive'}
                  value={formData.status.value || 'Inactive'}
                  name='radio-buttons-group'
                  onChange={(e) => onCtaStatusChange(e)}
                >
                  <div className='menu-active-status'>
                    <FormControlLabel
                      value='Active'
                      control={<Radio className='radio' />}
                      label='Active'
                      className='me-5'
                    />
                  </div>
                  <FormControlLabel value='Inactive' control={<Radio />} label='Inactive' />
                </RadioGroup>
              </FormControl>
              {formData?.status.value === 'Active' && (
                <div className='row'>
                  <div className='col-md-6 mb-3'>
                    <CustomTextField
                      item={formData.ctaTitle}
                      handleInputChange={(e) => {
                        setFormData({ ctaTitle: e });
                      }}
                      maxLength={60}
                      endAdornment={true}
                      characterCount={true}
                    />
                  </div>
                  <div className='col-md-6 mb-3'>
                    <CustomSelect
                      item={formData.redirectOption}
                      handleInputChange={(e) => {
                        setFormData({ redirectOption: e });
                      }}
                      labelField='name'
                      valueField='value'
                      options={REDIRECT_OPTIONS}
                      hideNullOption={true}
                    />
                  </div>
                  {formData?.redirectOption.value === 'External URL' && (
                    <div className='col mb-3'>
                      <CustomTextField
                        item={formData.redirectUrl}
                        handleInputChange={(e) => {
                          setFormData({ redirectUrl: e });
                        }}
                        endAdornment={true}
                        characterCount={false}
                        multiline={true}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
          {tabValue === 5 && (
            <div className='row px-3 w-100 d-flex mt-4'>
              <div className='col-md-12 mb-3'>
                <h4 className='tab-title '>Media</h4>
                <ImageUpload
                  uploadedImages={formData.images.value}
                  imgList={rawImages}
                  onImageListUpdated={onImageListUpdated}
                  onUploadedImageRemoval={onUploadedImageRemoval}
                  onImagesLoading={(status) => {
                    setLoading(status);
                  }}
                  videoImageUrl={videoImageUrl}
                  onVideoImageUrlChange={setVideoImageUrl}
                  gifImageUrl={gifImageUrl}
                  onGifImageUrlChange={setGifImageUrl}
                  videoList={rawVideos}
                  gifList={rawGifs}
                  onVideoListUpdated={setRawVideos}
                  onGifListUpdated={setRawGifs}
                  hotelId={hotelId}
                  groupId={groupId}
                  propertyType={SPA_TYPE}
                  onVideoError={setHasVideoError}
                  onThumbnailUploading={setIsThumbnailUploading}
                  onVideoLoading={setIsVideoLoading}
                  onGifLoading={setIsGifLoading}
                />
              </div>
            </div>
          )}
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            {tabValue < 5 ? (
              <Button
                variant='contained'
                color='primary'
                onClick={onNextClick}
                size='large'
                className='me-3'
                disabled={
                  isTabInValid ||
                  hasVideoError ||
                  isThumbnailUploading ||
                  isVideoLoading ||
                  isGifLoading ||
                  (tabValue === 1 && (!customTime || customTime.length === 0))
                }
              >
                Next
              </Button>
            ) : (
              <Button
                disabled={loading || hasVideoError || isThumbnailUploading || isVideoLoading || isGifLoading}
                onClick={handleSubmit}
                variant='contained'
                color='primary'
                className='me-3'
                size='large'
              >
                {spaInfoItem ? 'Update' : 'Add'}
              </Button>
            )}
            <Button
              disabled={loading}
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
          {loading && <div className='pt-4 col-md-12'>{<LinearProgressBar />}</div>}
        </div>
      </div>
    </form>
  );
};

export default SpaInfoCreate;
